import axios from 'axios';
import { axiosInstance } from '../interceptor';

const API_URL = `${process.env.REACT_APP_API_URL}payment`
// `${process.env.REACT_APP_API_URL}payment`;


export const fetchWidthrawRequest = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}/withdraw-requesting`,{
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response, "response return ")
      return response;
    } catch (error) {
      console.error('Error fetching tournaments:', error);
      throw error;
    }
  };


  export const approveWidthrawRequest = async (data) => {
    try {
      const response = await axiosInstance.patch(
        `${API_URL}/withdraw-amount`,
        {
          body: {
            "id":data.id,
            "userId":data.user_id,
            "amount":data.amount,
            "transaction_id":data.transaction_id
          },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response.data.data, "response return ")
      return response;
    } catch (error) {
      console.error('Error fetching tournaments:', error);
      throw error;
    }
  }